import { render, staticRenderFns } from "./live-login.vue?vue&type=template&id=72954beb&scoped=true&"
import script from "./live-login.vue?vue&type=script&lang=js&"
export * from "./live-login.vue?vue&type=script&lang=js&"
import style0 from "./live-login.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./live-login.vue?vue&type=style&index=1&id=72954beb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72954beb",
  null
  
)

export default component.exports